(() => {
    class ListLandingPages {

        /**
         * @type {() => import("moment").Moment}
         */
        moment
        constructor(
            $q,
            $scope,
            $state,
            moment,
            NgTableParams,
            NgTableEventsChannel,
            LocalisationService,
            LandingPagesService,
            PermissionService
        ) {
            NgTableEventsChannel.onPagesChanged(this.scrollToTop.bind(this), $scope);
            this.moment = moment;
            this._state = $state;
            this.filterText = ''
            this.landingPages = []
            this.filter = {
                q: '',
                draft: true,
                active: true,
                ended: false,
                scheduled: false,
                brandId: $state.params.brandId
            }

            this.tableParams = new NgTableParams({
                filter: this.filter,
                filterDelay: 500,
                page: 1,
                count: Dashboard.NgTableParams.InitialCount
            }, {
                getData: (params) => {
                    const deferred = $q.defer()
                    const count = params.count();
                    const page = params.page();
                    const filter = params.filter()
                    LandingPagesService.fetchLandingPages(filter, page, count)
                        .then((data) => {
                            const mapped = data.LandingPages.map((item) => {

                                return {
                                    ...item,
                                    Status: this.resolveLandingPageStatus({
                                        publishedDate: item.PublishedAt,
                                        startDate: item.StartDate,
                                        endDate: item.EndDate
                                    }),
                                    StartDate: LocalisationService.formatDateShort(item.StartDate),
                                    EndDate: LocalisationService.formatDateShort(item.EndDate),
                                    CreatedDate: LocalisationService.formatDateShort(item.CreatedDate),
                                    ModifiedDate: LocalisationService.formatDateShort(item.ModifiedDate)
                                }
                            })

                            Dashboard.helpers.tableHelper.useCount(params, data.Total)

                            deferred.resolve(mapped)
                        })

                    return deferred.promise
                }
            });

            this.permissionService = PermissionService;
            this.checkPermissions();
        }

        checkPermissions() {
            const { AddLandingPage, EditLandingPage } = Dashboard.Models.Lookups.Permissions
            this.showAddNewPageButton = this.permissionService.doesUserHaveAnyPermission([ AddLandingPage ])
            this.showEditPageButton = this.permissionService.doesUserHaveAnyPermission([ EditLandingPage ])
        }

        resolveLandingPageStatus({publishedDate, startDate, endDate}) {
            if (publishedDate === null) {
                return "Draft"
            }
            if (this.moment().isAfter(publishedDate) && this.moment().isBefore(startDate)) {
                return "Scheduled"
            }

            if (this.moment().isAfter(publishedDate) && this.moment().isBetween(startDate, endDate)) {
                return "Active"
            }
            if (this.moment().isAfter(publishedDate) && this.moment().isAfter(endDate)) {
                return "Ended"
            }
            return "unknown";
        }

        addNewPage() {
            this._state.go("app.landingpages.details", this._state.params)
        }

        editLandingPage(id) {
            this._state.go("app.landingpages.details", { ...this._state.params, pageId: id })
        }

        scrollToTop() {
            document.querySelector("body")
                .scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                });
        }
    }

    angular.module("dashboard")
        .component("listLandingPages", {
            templateUrl: "components/landingpages/listlandingpages.75222bf1.html",
            bindings: {},
            controller: [
                "$q",
                "$scope",
                "$state",
                "moment",
                "NgTableParams",
                "ngTableEventsChannel",
                "LocalisationService",
                "LandingPagesService",
                "PermissionService",
                ListLandingPages
            ]
        });
})();
